<h1 class="d_subtitulo">{{_labelLinks}}</h1>
<div class="d_principalin">
    <!--CARDS-->
    @for (item of dataLinks; track $index) {
    <div class="d_principalconte">
        <div class="d_principalind">{{item.label}}</div>
        <div class="d_principaldata">
            @for (libro of item.items; track $index) {
            <p (click)="onOpenUrlTarget(libro.url,item.urlBase ?? '')" class="d_principaldataoption">{{libro.label}}</p>

            }
            <!-- <p class="d_principaldataoption">Múltiples lenguajes.</p>
            <p class="d_principaldataoption">Libro de proyectos de Aula.</p>
            <p class="d_principaldataoption">Libro de proyectos Comunitarios.</p>
            <p class="d_principaldataoption">Libro de proyectos escolares.</p>
            <p class="d_principaldataoption">Nuestros saberes: Libro para alumnos, maestros y familia.</p>
            <p class="d_principaldataoption">Múltiples lenguajes. Trazos y palabras.</p>-->

        </div>

    </div>
    }
</div>
